import type { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { Intent, IntentController } from '@jet/environment/dispatching';
import { isSome } from '@jet/environment/types/optional';

export interface StaticCanonicalController<I extends Intent<unknown>>
    extends IntentController<I> {
    /**
     * Immediately build the canonical URL for `intent`. If the URL is not
     * immediately computable (ie. would require a network fetch), then
     * `undefined` is returned.
     *
     * @param intent intent for which to build the canonical
     * @param objectGraph app Object Graph
     * @return canonical URL or undefined (if it is asynchronous)
     */
    staticCanonicalUrlFor(
        intent: I,
        objectGraph: ObjectGraph,
    ): string | undefined;
}

export function isStaticCanonicalController<I extends Intent<unknown>>(
    controller: IntentController<I>,
): controller is StaticCanonicalController<I> {
    return isSome(controller['staticCanonicalUrlFor']);
}
